import React from 'react';
import {
  IUseCrmSearchDirectoryEntriesFullSearchParams,
  useCrmSearchDirectoryEntriesFullSearch,
} from 'services/CrmApi/queries/useCrmSearchDirectoryEntriesFullSearch';
import { IDirectoryEntrySimpleSearchResult } from 'services/CrmApi/types/DirectoryEntry';
import { useDebounce } from 'hooks/useDebounce';
import { InternalDirectoryEntriesSearch } from './InternalDirectoryEntriesSearch';

interface IProps {
  value: string;
  onChange: (value: string | null, directoryEntry?: IDirectoryEntrySimpleSearchResult) => void;
  companyTypeCodes: string[];
  excludeIds?: string[];
  className?: string;
  disabled?: boolean;
}

export const ExistingDirectoryEntriesFullSearch: React.FC<IProps> = ({
  value,
  onChange,
  companyTypeCodes,
  excludeIds = [],
  className,
  disabled = false,
}) => {
  const [searchTerm, setSearchTerm, debouncedSearchTerm] = useDebounce(value, 500);

  const params: IUseCrmSearchDirectoryEntriesFullSearchParams = {
    filter: {
      term: debouncedSearchTerm ?? '',
      companyTypeCodes,
    },
    pagination: {
      limit: 100,
      offset: 0,
    },
  };

  const { crmDirectoryEntries, directoryEntries } = useCrmSearchDirectoryEntriesFullSearch(params);

  return (
    <InternalDirectoryEntriesSearch
      value={value}
      onChange={onChange}
      className={className}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      excludeIds={excludeIds}
      directoryEntries={directoryEntries}
      isFetching={crmDirectoryEntries.isFetching}
      isFetched={crmDirectoryEntries.isFetched}
      disabled={disabled}
    />
  );
};
